import styled, {css} from 'styled-components/native';
import TextInputMask from 'react-native-text-input-mask';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

interface InputError {
  error: boolean;
}

export const Container = styled.View``;

export const InputContainer = styled.View<InputError>`
  border-style: solid;

  border-bottom-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
  flex-direction: row;
  height: ${RFValue(40)}px;
  justify-content: space-between;
  align-items: center;

  ${({error}) =>
    error &&
    css`
      border-color: ${({theme}) => theme.colors.attention};
    `}
`;

//@ts-ignore
export const Input = styled(TextInputMask)<InputError>`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
  height: ${RFValue(45)}px;
  ${({error}) =>
    error &&
    css`
      color: ${({theme}) => theme.colors.attention};
    `}
  flex: 1;
`;

export const Error = styled.Text`
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.attention};
  font-family: ${({theme}) => theme.fonts.medium};
  margin-top: ${RFValue(6)}px;
`;

export const ShowPassword = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
  height: ${RFValue(55)}px;
  padding: 0 14px;
`;

export const Icon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.blue};
`;
